import { ChangeDetectionStrategy, Component } from '@angular/core';
import { provideUiAccordionConfig } from '@df/ui/accordion/accordion.config';
import { UiAccordionDirective } from '@df/ui/accordion/accordion.directive';

@Component({
    selector: 'accordion',
    templateUrl: './accordion.component.html',
    styleUrl: './accordion.component.scss',
    hostDirectives: [
        {
            directive: UiAccordionDirective,
            inputs: [
                'uiAccordionValue:value',
                'uiAccordionType:type',
                'uiAccordionCollapsible:collapsible',
                'uiAccordionDisabled:disabled',
                'uiAccordionOrientation:orientation'
            ]
        }
    ],
    providers: [provideUiAccordionConfig({ collapsible: true })],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionComponent {}
